import React from 'react';
import { ActivityIcon, ClipboardCheckIcon, GraduationCapIcon, PhoneIcon, RouteIcon, UsersRoundIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
const REVIEW_FACTORS = [{
  label: 'Patient needs',
  icon: UsersRoundIcon
}, {
  label: 'Practice workflow',
  icon: ActivityIcon
}, {
  label: 'Training capacity',
  icon: GraduationCapIcon
}, {
  label: 'Implementation plan',
  icon: RouteIcon
}];
export function WelcomeVideo() {
  return <section className="before-you-buy w-full overflow-hidden bg-white px-4 py-20 sm:px-0 sm:py-24" data-id="element-300" data-mp="32ng9byh4seb5">
      <div className="before-you-buy__inner mx-auto grid w-full max-w-[358px] items-center gap-10 sm:max-w-7xl sm:px-8 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-301" data-mp="3geusc5b1gfi7">
        <div className="before-you-buy__copy w-full min-w-0" data-id="element-302" data-mp="3bnctbmsksozv">
          <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-303" data-mp="2ny1wuhi9dgrj">
            BEFORE YOU BUY
          </p>
          <h2 className="before-you-buy__heading mt-3 w-full max-w-full whitespace-normal break-words font-display text-[30px] font-bold leading-[1.08] tracking-tight text-navy sm:max-w-xl sm:text-[2.4rem] sm:leading-tight" data-id="element-304" data-mp="2jw6zfo3g7nj1">
            <span className="block sm:inline" data-id="element-305" data-mp="5q6n84idd94c">Start With the Fit,</span>{' '}
            <span className="block sm:inline" data-id="element-306" data-mp="akaygzyo43b8">Not the Catalog</span>
          </h2>
          <p className="before-you-buy__copy-text mt-5 w-full max-w-full text-[16px] leading-relaxed text-charcoal/75 sm:max-w-xl" data-id="element-307" data-mp="fh19v9zj2aqb">
            A quick conversation can help a practice avoid investing in
            technology that does not match its patients, workflow, budget, or
            training capacity. JAG Medical Solutions helps doctors compare
            modalities, understand implementation needs, and choose equipment
            with a clear plan for adoption.
          </p>
          <a href={CONTACT.phoneHref} className="before-you-buy__cta mt-8 inline-flex max-w-full items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-308" data-mp="138ggheyc7e7d">
            <PhoneIcon className="h-[18px] w-[18px] shrink-0" data-id="element-309" data-mp="2zd604dkah1c3" />
            Call Before You Buy
          </a>
        </div>

        <aside className="before-you-buy__card mx-auto w-full min-w-0 rounded-3xl border border-slate-200 bg-white shadow-[0_28px_65px_-30px_rgba(26,27,75,0.38)] sm:max-w-none" data-id="element-310" data-mp="398g4v922nmtk">
          <div className="before-you-buy__visual relative h-40 overflow-hidden bg-navy sm:h-48" data-id="element-311" data-mp="2gkajck371tso">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/3b34887f-f846-4447-89ca-77da7e827282.jpg" alt="Therapeutic modality equipment in a practice-fit review" className="absolute inset-0 h-full w-full object-cover object-right opacity-90" data-id="element-312" data-mp="2gihdh70endlq" />
            <div className="absolute inset-0 bg-navy/35" data-id="element-313" data-mp="1xu2o0o5qk7n1" />
            <div className="before-you-buy__visual-labels absolute inset-x-5 top-5 flex min-w-0 items-start justify-between gap-3 sm:inset-x-6 sm:top-6" data-id="element-314" data-mp="1xtkit213ij2z">
              <span className="inline-flex min-w-0 items-center gap-2 rounded-full border border-teal-light/40 bg-navy/85 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-315" data-mp="1sgueghyahvs6">
                <ClipboardCheckIcon className="h-3.5 w-3.5 shrink-0 text-teal-light" data-id="element-316" data-mp="1ipzu5j4lt69d" />
                Before You Buy
              </span>
              <span className="hidden rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-[10px] font-semibold text-white sm:block" data-id="element-317" data-mp="26h579qj5tkfz">
                Fit first. Buy second.
              </span>
            </div>
            <div className="absolute bottom-5 left-5 sm:bottom-6 sm:left-6" data-id="element-318" data-mp="1wkjzwyjo3x8z">
              <div className="h-1 w-10 rounded-full bg-teal-light" data-id="element-319" data-mp="21ffwmbzun8sf" />
              <p className="mt-3 text-[10px] font-bold uppercase tracking-[0.18em] text-white/65" data-id="element-320" data-mp="l1zfejyhabk9">
                Practice Equipment Fit
              </p>
            </div>
          </div>

          <div className="before-you-buy__card-body p-5 sm:p-6" data-id="element-321" data-mp="169i7lbmit9w9">
            <h3 className="font-display text-xl font-bold text-navy" data-id="element-322" data-mp="11ijpq7lvw3qw">
              Equipment Fit Review
            </h3>
            <p className="mt-2 max-w-full text-sm leading-relaxed text-charcoal/65 sm:max-w-md" data-id="element-323" data-mp="wixeg3pm8xkq">
              A clearer way to compare equipment before it becomes a purchase.
            </p>

            <div className="before-you-buy__factors mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-324" data-mp="1p7umle045dzr">
              {REVIEW_FACTORS.map(({
              label,
              icon: Icon
            }) => <div key={label} className="before-you-buy__factor min-w-0 rounded-xl border border-slate-100 bg-slate-50 px-3.5 py-3" data-id="element-325" data-mp="1k9szmhzkguj0">
                  <div className="flex items-center gap-2.5" data-id="element-326" data-mp="1aabv43w1wmom">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-327" data-mp="3vb1i4ui0gl7">
                      <Icon className="h-3.5 w-3.5" data-id="element-328" data-mp="3v0b1i8xg6np4" />
                    </span>
                    <span className="min-w-0 text-[12px] font-semibold leading-snug text-navy" data-id="element-329" data-mp="2ajtgf78i29jt">
                      {label}
                    </span>
                  </div>
                  <div className="mt-3 h-px w-8 bg-teal/60" data-id="element-330" data-mp="2kh7tcwv7sg7d" />
                </div>)}
            </div>

            <div className="before-you-buy__rollout mt-5 flex items-center gap-3 rounded-xl border border-teal/20 bg-teal/[0.06] px-3.5 py-3" data-id="element-331" data-mp="2p8g7u7beirre">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-navy text-teal-light" data-id="element-332" data-mp="2u6rgiepymw81">
                <RouteIcon className="h-4 w-4" data-id="element-333" data-mp="2yah16t3iktns" />
              </span>
              <div className="min-w-0" data-id="element-334" data-mp="3388tho82mhsi">
                <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-teal" data-id="element-335" data-mp="386senmeubpjt">
                  Implementation Plan
                </p>
                <p className="mt-0.5 text-[12px] font-medium leading-snug text-navy/75" data-id="element-336" data-mp="18uzpud27hqi6">
                  Compare the fit, then plan the rollout.
                </p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </section>;
}